export default (function () {
  function videoPopup() {
    var body = jQuery('body');
    var activeClass = 'video-active';
    var video = jQuery('.video-popup__wrap');
    var videoCaption = video.find('.video-popup__caption');
    var videoHolder = video.find('.embed-video');
    jQuery('.video-opener').on('click', function (e) {
      e.preventDefault();
      body.addClass(activeClass);
      var link = jQuery(this);
      var videoLink = link.attr('href');
      var heading = link.find('>h3').clone();
      var iframe = jQuery('<iframe>');
      iframe.attr('src', videoLink);
      videoHolder.append(iframe);
      videoCaption.append(heading);
      var twoBlockHeading = link.parent().find('>h3').clone();
      videoCaption.append(twoBlockHeading);
      var newsHeading = link.parent().find('>h4').clone();
      videoCaption.append(newsHeading);
    });
    jQuery('.video-close').on('click', function (e) {
      e.preventDefault();
      body.removeClass(activeClass);
      videoCaption.html('');
      videoHolder.html('');
    });
    jQuery(document).click(function (event) {
      if (!jQuery(event.target).closest('.video-popup__wrap, .video-opener').length) {
        body.removeClass(activeClass);
        videoCaption.html('');
        videoHolder.html('');
      }
    });
  }

  videoPopup();
});